<template>
  <div class="page_ table_textc">
    <div>
      <a-form layout="inline">
        <!-- <a-form-item label="批单生效日期">
                <a-date-picker @change="onChange" :showToday='false' :allowClear='false' v-model="timeValue" placeholder="请选择日期" />
            </a-form-item> -->
        <a-form-item label="保单号 ">
          <a-input
            class="min_input_"
            style="width: 200px;"
            v-model="policyNo"
            placeholder="请输入保单号"
          ></a-input>
        </a-form-item>
        <a-form-item label="投保人">
          <a-input v-model="holderName"></a-input>
        </a-form-item>
        <a-form-item label="被保人">
          <a-input v-model="insuredName"></a-input>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="searchData()">查询</a-button>
          <a-button style="margin-left: 8px;" type="default" @click="initData()"
            >重置</a-button
          >
        </a-form-item>
      </a-form>
    </div>
    <a-table
      style="margin-top: 17px;"
      :columns="columns"
      :dataSource="tableData"
      :pagination="pagination"
      @change="handlePageChange"
      class="table_b"
    >
      <span slot="operation" slot-scope="text, record" class="span_btn">
        <a :href="record.batchDownLoadUrl">批单下载</a>
      </span>
    </a-table>
  </div>
</template>
<style lang="scss" scoped>
.table_b {
  border: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
<script>
import api from "@/utils/api";
import navbar from "../components/navbar";
const columns = [
  {
    title: "保单号",
    key: "policyNo",
    dataIndex: "policyNo",
  },
//   {
//     title: "批单号",
//     key: "batchNo",
//     dataIndex: "batchNo",
//   },
  {
    title: "产品名称",
    key: "productName",
    dataIndex: "productName",
  },
  {
    title: "投保人",
    key: "holderName",
    dataIndex: "holderName",
  },
  {
    title: "批单生效日期",
    key: "startDate",
    dataIndex: "startDate",
  },
  {
    title: "保费变化",
    key: "price",
    dataIndex: "price",
  },
  {
    title: "批改结果",
    key: "status",
    dataIndex: "status",
  },
  {
    title: "操作",
    key: "1",
    scopedSlots: { customRender: "operation" },
  },
];

export default {
  data() {
    document.title = "批改查询";
    return {
      columns,
      tableData: [],
      pagination: {
        total: 0,
        pageSize: 20,
        pageNum: 1,
      },
      pageNum: "1",
      pageSize: "20",
      timeValue: undefined,
      policyNo:'',
      startDate: "",
      holderName: "",
      insuredName: "",
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    handlePageChange(e) {
      this.pageNum = e.current;
      this.initData();
    },
    onChange(date, dateString) {
      this.startDate = dateString;
    },
    initData() {
      this.timeValue = undefined;
      this.policyNo = ''
      this.startDate = "";
      this.holderName = "";
      this.insuredName = "";
      let queryData = { pageNum: this.pageNum, pageSize: this.pageSize };
      this.queryData(queryData);
    },
    queryData(queryData) {
      api.findUserBatchPoloicy(queryData).then((res) => {
        if (res.data.returnCode === "0000" || res.data.data.list != null) {
          this.tableData = res.data.data.list.map((item, index) => {
            if (item.status === "1") {
              item.status = "批改成功";
            } else {
              item.status = "批改失败";
            }
            item.key = index;
            return item;
          });
          this.pagination.total = res.data.data.total;
        }
      });
    },
    searchData() {
      let queryData = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        startDate: this.startDate,
        holderName: this.holderName,
        insuredName: this.insuredName,
        policyNo: this.policyNo
      };
      this.queryData(queryData);
    },
  },
};
</script>
